const noop = () => undefined;
class NewRelicLogger {
  logLevel = {};
  log = noop;
  setUserId = noop;
  setAttribute = noop;
  setUserContext = noop;
}

export default new NewRelicLogger();
